<template>
  <div :style="{padding: '10px'}">
    <div>**** {{item.type}} ****</div>
    <div>{{layer1}}</div>
    <SelectorEdit :style="{marginLeft: '40px'}" v-for="(itm, i) in item.contents" :key="i" :item="itm">
    </SelectorEdit>
  </div>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    layer1 () {
      const item = JSON.parse(JSON.stringify(this.item))
      delete item.contents
      return item
    }
  }

}
</script>

<style>

</style>
